const locale = {
  APPLICATIONS: 'Applications',
  TheRegistry: 'The Registry',
  ThePatients: 'Patients',
  WaitingList: 'Waiting List',
  Telephony: 'Telephony',
  Doctors: 'Doctors',
  WorkingHours: 'Working Hours',
  Access: 'Access',
  Testimonials: 'Testimonials',
  Services: 'Services',
  Resources: 'Resources',
  EmailSMS: 'Email and SMS',
  AutoNotifications: 'Auto Notifications',
  MailOut: 'Mail Out',
  Balance: 'Balance',
  MessageHistory: 'Message History',
  Analytics: 'Analytics',
  GeneralAnalytics: 'General Analytics',
  Employees: 'Employees',
  Employee: "Employee",
  BlackBox: 'Black Box',
  MaterialAccounting: 'Material Accounting',
  Products: 'Products',
  OrderProducts: 'Ordered products',
  Categories: 'Categories',
  Brands: 'Brands',
  Suppliers: 'Suppliers',
  FlowOfGoods: 'Flow Of Goods',
  Storages: 'Storages',
  Inventory: 'Inventory',
  Payroll: 'Payroll',
  SalarySettings: 'Salary Settings',
  OnlineBooking: 'Online Booking',
  CompanysSettings: 'Company Settings',
  Payment: 'Payment',
  SignIn: 'Sign In',
  SignedOut: 'Signed Out',
  UserName: 'User Name',
  Password: 'Password',
  SignOut: 'Sign Out',
  Branch: 'Branch',
  Company: 'Company',
  Save: 'Save',
  AboutCompany: 'About Company',
  TheTitleOfTheCompany: 'The Title Of The Company',
  BankingDetails: 'Banking Details',
  EnterTheBankingDetails: 'Enter The Banking Details',
  TheNameOfTheCompany: 'The Name Of The Company',
  Activity: 'Activity',
  PhoneNumberOwners: 'Phone Number (Owners)',
  TheCompanysAddress: 'The Company\'s Address',
  City: 'City',
  SessionHistoryRetentionPeriod: 'Session History Retention Period',
  SettingsAreSaved: 'Settings Are Saved',
  PhoneNumber: 'Phone Number',
  EmailAddress: 'Email Address',
  CategoryPermission: 'Category Permission',
  Function: 'Function',
  Jurnal: 'Journal',
  Online: 'Online',
  NewAdministrator: 'New Administrator',
  NewDoctor: 'New Doctor',
  SettingsProfile: 'Settings Profile',
  Name: 'Name',
  Surname: 'Surname',
  EmailProgramAccess: 'Email (Program Access)',
  Dostup: 'Access',
  AvailableTimeForOnlineRegistration: 'Available Time For Online Registration',
  Phone: 'Phone',
  Access: 'Access',
  Photo: 'Photo',
  BeginningOfWork: 'Beginning Of Work',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Mon: 'Mon',
  Tues: 'Tues',
  Wed: 'Wed',
  Thur: 'Thur',
  Fri: 'Fri',
  Sat: 'Sat',
  Sun: 'Sun',
  TODAY: 'TODAY',
  Description: 'Description',
  Patients: 'Patients',
  Birthday: 'Birthday',
  Gender: 'Gender',
  Discount: 'Discount',
  EntriesInmonths53: '5+ entries in 3 months',
  EntriesInmonths23: '2+ entries in 3 months',
  HaventRegis3: 'haven\'t registered for more than 3 months',
  HaventRegis6: 'haven\'t registered for more than 6 months',
  NotReg: 'not registered',
  InTheLast30days: 'In the last 30 days',
  CantSignUpOnline: 'can\'t sign up online',
  CanceledCO: 'canceled appointments % is higher than completed ones',
  Filtr: 'Filters',
  MostActive: 'Most Active',
  Permanent: 'Permanent',
  NotActive: 'Not Active',
  Missing: 'Missing',
  DidntVisit: 'Didn\'t Visit',
  NewClients: 'New Clients',
  BlackList: 'Black List',
  Problematic: 'Problematic',
  AllInformation: 'All Information',
  CardNumbers: 'Card Numbers',
  SurnameD: 'SurnameD',
  FamilyCard: 'Family Card',
  Boy: 'Boy',
  Girl: 'Girl',
  GenderSelect: 'Gender Select',
  Pasport: 'Passport',
  TheNote: 'The Note',
  LegalRepesentative: 'Legal Representative',
  SocialNetwork: 'Social Network',
  Address: 'Address',
  LoyaltyPrograms: 'Loyalty Programs',
  Insurance: 'Insurance',
  Newsletters: 'Newsletters',
  AutoNote: 'Auto Note',
  NewClient: 'New Client',
  Country: 'Country',
  Region: 'Region',
  PersonalDiscount: 'Personal Discount',
  InsuranceCompany: 'Insurance Company',
  NumberPolice: 'Number of Police',
  NewPatient: 'New Patient',
  English: 'English',
  Russian: 'Russian',
  Uzbek: 'Uzbek',
  UzbekKril: "Uzbek - Kril",
  SelectABranch: 'Select a branch',
  SearchClientServicesCreatingVisit: 'Search for a client, services, creating a visit',
  Partner: "Partner",
  AvailableTimeForOnlineRegistration: "Available Time for Online Registration",
  Specialization: "Specialization",
  Short: "Low",
  Average: "Average",
  Admin: "Admin",
  DeleteEmploye: "Delete Employee?",
  Delete: "Delete",
  Cancel: "Cancel",
  SuccessfulSaved: "Successfully Saved",
  NameN: "Name",
  NameProduct: "Product Name",
  CodeProduct: "Product Code",
  NominalVolume: "Nominal Volume",
  Remainder: "Remainder",
  Reserve: "Reserve",
  Unit: "Unit of Measure",
  LowBalanceNotification: "Low Balance Notification",
  EnableWarehouseControl: "Enable Warehouse Control",
  EnableRetailSales: "Enable Retail Sales",
  Brend: "Brand",
  Brands: "Brands",
  Category: "Category",
  NameCategory: "Category Name",
  NewCategory: "New Category",
  EditCategory: "Edit Category",
  DeleteCategory: "Delete Category?",
  SearchCategories: "Search Categories",
  Seria: "Series",
  Serias: "Series",
  NameSeria: "Series Name",
  NewSeria: "New Series",
  EditSeria: "Edit Series",
  DeleteSeria: "Delete Series?",
  SearchSerias: "Search Series",
  NameBrands: "Brand Name",
  NewBrands: "New Brand",
  EditBrands: "Edit Brand",
  DeleteBrands: "Delete Brand?",
  SearchBrands: "Search Brands",
  NameResources: "Resource Name",
  NewResources: "New Resource",
  EditResources: "Edit Resource",
  DeleteResources: "Delete Resource?",
  SearchResources: "Search Resources",
  NewProduct: "New Product",
  Invoice: "Invoice",
  EditProduct: "Edit Product",
  DeleteProduct: "Delete Product?",
  SearchProduct: "Search Products",
  NameSuppliers: "Supplier",
  Suppliers: "Suppliers",
  NewSuppliers: "New Supplier",
  EditSuppliers: "Edit Supplier",
  DeleteSuppliers: "Delete Supplier?",
  SearchSuppliers: "Search Suppliers",
  WebSite: "Website",
  NameStoreHouses: "Warehouse Name",
  NewStoreHouses: "New Warehouse",
  EditStoreHouses: "Edit Warehouse",
  DeleteStoreHouses: "Delete Warehouse?",
  SearchStoreHouses: "Search Warehouses",
  RetailPrice: "Retail Price",
  SupplierPrice: "Supplier Price",
  DownloadXLS: "Download XLS",
  All: "All",
  From: "From",
  To: "To",
  Operation: "Operation",
  WorkingDays: "Working Days",
  WorkingHours: "Working Hours",
  HoursForServices: "Hours for Services",
  ServicesCarriedOut: "Services Carried Out",
  AmountOfServices: "Amount of Services",
  ProductsSold: "Products Sold",
  AmountOfGoods: "Amount of Goods",
  EmployeeIncome: "Employee Income",
  CompanyRevenue: "Company Revenue",
  StartTime: "Start Time",
  ServiceTime: "Service Time",
  Service: "Service",
  OfTheService: "% of Service",
  Product: "Product",
  OfTheProduct: "% of Product",
  IncomeEmployees: "Income Employees",
  CompanyRevenue: "Company revenue",
  ServicesProvided: "Services Provided",
  ItemsSold: "Items Sold",
  SalarySettings: "Salary Settings",
  SelectingABet: "Selecting Bet",
  MonthlySalary: "Monthly Salary",
  GuaranteedSalary: "Guaranteed Salary",
  PercentageOnSales: "Percentage on Sales",
  Rates: "Rates",
  Hours: "Hours",
  EnterCategoryName: "Enter Category Name",
  ES1: "SMS Notifications",
  ES2: "(Notifications disabled. Insufficient balance)",
  ES3: "Auto Notifications (on successful registration, visit reminder, cancellation, reschedule)",
  ES4: "Notifications on registration",
  ES5: "Notifications on reschedule",
  ES6: "Reminder Interval for Upcoming Visit",
  ES7: "Send one day before:",
  ES8: "Notify when SMS and Email balance is below:",
  ES9: "Try to avoid booking clients at late hours as clients receive instant SMS notifications about the booking",
  ES10: "Email Notifications",
  ES11: "Auto notifications (on successful booking, visit reminder, cancellation, rescheduling)",
  ES12: "Notifications on visit cancellation",
  ES13: "Visit reminders",
  ES14: "Visit link in SMS",
  ES15: "Service name in SMS",
  ES16: "New client confirmation option",
  ES17: "SMS auto reply",
  ES18: "Email auto reply",
  before: "before",
  TurnOff: "Off",
  EL1: "SMS sending",
  EL2: "Number of SMS:",
  EL3: "Number of characters:",
  EL4: "Enter text",
  EL5: "Recipient selection",
  EL6: "All clients",
  EL7: "All employees",
  EL8: "Create mailing",
  EB1: "Number of SMS:",
  EB2: "Number of Emails:",
  EB3: "Top up balance",
  EH1: "To number",
  Text: "Text",
  EH2: "Number of SMS",
  EHNO: "Resources are equipment, rooms, devices used for certain services that cannot be occupied by different employees simultaneously. After creating a resource, activate it in the required services.",
  Resources: "Resources",
  Date: "Date",
  NewServices: "New service",
  DeleteGroups: "Delete service group?",
  DeleteGroupsInfo: "This action may result in deleting visits in the booking journal. Please check and save visits if they exist.",
  NewEntry: "New entry",
  Entry: "Entry",
  min: "min",
  Beginning: "Start",
  Duration: "Duration",
  OneTimeDiscount: "One-time discount",
  Executor: "Executor",
  ActualPrice: "Actual price",
  AddAService: "Add service",
  AddHelpers: "Add helpers",
  AddingAPatient: "Add patient",
  Telefon: "Phone",
  AllAmount: "Total amount",
  Day: "Day",
  Month: "Month",
  Year: "Year",
  Profile: "Profile",
  VisitHistory: "Visit history",
  MedCard: "Medical card",
  VisitAmount: "Visit amount",
  MiddleCheck: "Average check",
  Canceled: "Canceled",
  Done: "Done",
  VisitAll: "Total visits",
  Price: "Price",
  MinimalBudget: "Minimal budget",
  FinanceAnal: "Financial analytics",
  TotalRecords: "Total records",
  OnlineRecords: "Online records",
  JurnalRecords: "Journal records",
  SinceYes: "since yesterday",
  NewPatients: "New patients",
  RegularPatients: "Regular patients",
  NoPatients: "No patients",
  PatientsNotCome: "Patients didn't show up",
  NotCatgoryService: "If the category contains services, it cannot be deleted.",
  NameService: "Service name",
  DetailsServices: "Service details",
  SettingsService: "Service settings",
  LocalCurrency: "Local currency",
  Amountto: "Price from",
  AmountFrom: "Price to",
  AmountProduct: "Product cost (optional)",
  Details: "Details",
  EditServices: "Edit service",
  DeleteServices: "Delete service?",
  SearchServices: "Enter service name",
  Owner: "Owner",
  LichCalendar: "Personal calendar",
  Shop: "Shop",
  stock: "Warehouse",
  AddSales: "Add sales",
  HAddSR: "Add sales receipt",
  Buyer: "Buyer",
  Back: "Back",
  Code: "Code",
  Status: "Status",
  OrderPrice: "Order price",
  Instalment: "Installment",
  NameSubcategory: "Subcategory name",
  NewSubcategory: "New subcategory",
  EditSubcategory: "Edit subcategory",
  DeleteSubcategory: "Delete subcategory?",
  SearchSubcategories: "Search subcategories",
  Subcategories: "Subcategories",
  Subcategory: "Subcategory",
  Quantity: "Quantity",
  Add: "Add",
  Repair: "Repair",
  Order: "Order",
  Nomenclature: "Nomenclature",
  Purchase: "Purchase",
  Sales: "Sales",
  InterBranch: "Inter Branch",
  NothingAdded: "Nothing added",
  EditEntry: "Edit entry",
  ClientWaiting: "Client is waiting",
  ClientCome: "Client has arrived",
  ClientNo: "Client did not come",
  ClientSuccess: "Client confirmed",
  Master: "Master",
  Edit: "Edit",
  DeleteEntry: "Delete entry",
  Directorys: "Catalogs",
  Directory: "Catalog",
  NameDirectorys: "Catalog name",
  NewDirectorys: "New catalog",
  EditDirectorys: "Edit catalog",
  DeleteDirectorys: "Delete catalog",
  SearchDirectorys: "Search catalogs",
  MatrialTypes: "Material types",
  MatrialType: "Material type",
  NameMatrialTypes: "Material type name",
  NewMatrialTypes: "New material type",
  EditMatrialTypes: "Edit material type",
  DeleteMatrialTypes: "Delete material type",
  SearchMatrialTypes: "Search material types",
  ExecutorType: "Executor type",
  NameExecutorTypes: "Executor type name",
  NewExecutorTypes: "New executor type",
  EditExecutorTypes: "Edit executor type",
  DeleteExecutorTypes: "Delete executor type",
  SearchExecutorTypes: "Search executor types",
  ColourType: "Color",
  NameColourTypes: "Color name",
  NewColourTypes: "New color",
  EditColourTypes: "Edit color",
  DeleteColourTypes: "Delete color",
  SearchColourTypes: "Search colors",
  VentilationSize: "Ventilation size",
  NameVentilationSizes: "Ventilation size name",
  NewVentilationSizes: "New ventilation size",
  EditVentilationSizes: "Edit ventilation size",
  DeleteVentilationSizes: "Delete ventilation size",
  SearchVentilationSizes: "Search ventilation sizes",
  Client: "Client",
  Report: "Report",
  DebitOrderTransact: "Order transactions",
  DebitTotalTransact: "Total transactions",
  DebitTransactSummary: "Product report",
  ClientName: "Client name",
  Fullname: "Full name",
  VentilationType: "Units of measurement",
  Measure: "Measurement",
  AutoSalary: "Automatic salary",
  ProductsNo: "No product",
  ProductsAdd: "Add product",
  ListProducts: "Product list",
  Amount: "Amount",
  ProductsAmount: "Service cost",
  Waiting: "Waiting",
  RowsPerPage: "Rows per page",
  Consumptions: "Consumptions",
  Consumption: "Consumption",
  NameConsumptions: "Consumption name",
  NewConsumptions: "New consumption",
  EditConsumptions: "Edit consumption",
  DeleteConsumptions: "Delete consumption",
  SearchConsumptions: "Search consumptions",
  Success: "Successful",
  Expectations: "Expected",
  Vendor: "Vendor",
  RateAmount: "Discount",
  Date: "Date",
  Reset: "Reset",
  OptionType: "Option",
  NameOptionTypes: "Option name",
  NewOptionTypes: "New option",
  EditOptionTypes: "Edit option",
  DeleteOptionTypes: "Delete option",
  SearchOptionTypes: "Search options",
  TypeType: "Type",
  NameTypeTypes: "Type name",
  NewTypeTypes: "New type",
  EditTypeTypes: "Edit type",
  DeleteTypeTypes: "Delete type",
  SearchTypeTypes: "Search types",
  SerialType: "Serial type",
  NameSerialTypes: "Serial type name",
  NewSerialTypes: "New serial type",
  EditSerialTypes: "Edit serial type",
  DeleteSerialTypes: "Delete serial type",
  SearchSerialTypes: "Search serial types",
  Request: "Requests",
  AddRequest: "Add request",
  EnterProductName: "Enter product name",
  NotMandatory: "(Selection is not mandatory!)",
  Settings: "Settings",
  Today: "Today",
  Previous: "Previous",
  Next: "Next",
  Wait: "Not confirmed",
  Paid: "Paid",
  Finance: "Finance",
  CASH: "Cash",
  UZCARD: "Uzcard",
  HUMO: "Humo",
  TRANSFER: "Transfer",
  CLICK: "Click",
  SERTIFICAT: "IHMA",
  UZUM_NASIYA: "Uzum on credit",
  Payments: "Payments",
  Rollback: "Return",
  ExpenseType: "Expense type",
  NameExpenseTypes: "Expense type name",
  NewExpenseTypes: "New expense type",
  EditExpenseTypes: "Edit expense type",
  DeleteExpenseTypes: "Delete expense type",
  SearchExpenseTypes: "Search expense types",
  AmountOfAcceptedOrders: "Number of accepted orders",
  TotalAmount: "Total amount",
  CancelAmount: "Return amount",
  ExpenseAmount: "Expense amount",
  Total: "Total",
  Send: "Send",
  Login: "Log in",
  MY_PROFILE: "My profile",
  OldPassword: "Old password",
  NewPassword: "New password",
  EditPassword: "Change password",
  ShortName: "Short name",
  Loading: "Loading",
  AddFilial: "Add branch",
  SaveFilial: "Save",
  RECEPTION: "Reception",
  SearchPasient: "Search patient",
  Indicator: "Income/Expense",
  EmployeeProductivity: "Employee productivity",
  VisitCount: "Number of visits",
  ClientCount: "Number of clients",
  TopServices: "Popular services",
  WorkHourse: "Working hours",
  VisitHourse: "Visit hours",
  EmptyHourse: "Free hours",
  New: "New",
  Ear_id: "Right/Left",
  document_number: "Document number",
  shop_id: "Shop ID",
  serial_number: "Serial number",
  total_reverse_trans_amount: "Return amount",
  total_trans_amount: "Amount by nomenclature",
  total_order_amount: "Order amount",
  total_credit_amount: "Credit amount",
  FullOrderList: "Order list",
  TotalTransactSummary: "Total report",
  YearOfFilial: "Year of operation start",
  UnitPrice: "Unit price",
  NEACTIVE: "Inactive",
  ACTIVE: "Active",
  SpecializationType: "Specialization",
  NameSpecializationTypes: "Specialization name",
  NewSpecializationTypes: "New specialization",
  EditSpecializationTypes: "Edit specialization",
  DeleteSpecializationTypes: "Delete specialization",
  SearchSpecializationTypes: "Search specializations",
  PaymentHistory: "Payment history",
  IsDeleteClientOrder: "Sorry, the record cannot be deleted because the payment has already been made!",
  DocumentNumber: "Contract number",
  More: "More details",
  Income: "Income",
  Rollback: "Return",
  Debt: "Debt",
  Sold: "Sold",
  Repair: "Repair",
  Labaratory: "Laboratory",
  PHONE_NUMBER_DUBLICATE: "This number is already registered, please find it by phone or name!",
  DescLab: "Laboratory description",
  Send: "Sent",
  Working: "In progress",
  Acceptance: "Acceptance",
  Ready: "Ready",
  IsDeleteClientOrderPOR: "Sorry, the record cannot be deleted because there are items, orders, or repairs in the material list!",
  IsDeleteClientOrderSales: "Sorry, the record cannot be deleted because there are items, orders, or repairs in the sales list!",
  NotDelete: "Cannot be deleted!",
  SalesHistory: "Sales history",
  SelectDate: "Select date",
  ProductsType: "Product type",
  AllPrice: "Total amount",
  District: "District/City",
  SearchSeria: "Search series",
  Search: "Search",
  Sum: "Sum",
  CurrencyRate: "Currency rate",
  CurrencyHistory: "Exchange rate history",
  date: "Date",
  AddServices: "Add services",
  HowDidYouHearAboutUs: "How did you hear about us",
  ForgotPassword: "Forgot password?",
  NewEmailPassword: "A new password will be sent to this email address.",
  Materilas: "Materials",
  ClientHistory: "Client history",
  ProductNumber: "Product number",
  SorryNoProduct: "Sorry, such product was not found",
  Found: "Found",
  NoOrder: "No order",
  AddOrder: "Add order",
  Right: "Right",
  Left: "Left",
  OnsideColor: "Outer color",
  InColor: "Inner color",
  Size: "Size",
  UsedProducts: "Used products",
  ProductHistory: "Product history",
  Too: "To",
  Fromm: "From",
  SuccessfullyCompleted: "Successfully completed",
  DoYouWantToReturnTheGoods: "Do you want to return the goods?",
  YouAddedThisSeries: "You have already added this series",
  SeriaNumber: "Serial number",
  AvailableSerialNumbers: "Available serial numbers",
  AvailableQuantity: "Available quantity",
  FinishedProduct: "Finished product",
  FinishedProductConfirmation: "Finished product confirmation",
  NotRefundable: "Non-refundable",
  HearingAids: "Hearing aids",
  PersonalHearingAids: "Personal hearing aids",
  HearingAidParts: "Parts for hearing aids",
  OtherGoods: "Other goods",
  Location: "Location",
  NotificationAmount: "Notification amount",
  AvailableItems: "Items in stock",
  Transactions: "Transactions",
  NoProductToRepair: "No product to repair",
  EnterOnlyLatinLetters: "Enter only Latin letters!",
  Remainder: "Remainder",
  TotalCalculatedAmount: "Total calculated amount",
  Conclusion: "Conclusion",
  ThankYouLook: "Thank you! See you again.",
  ProductsAboutInfo: "Information about products",
  ServicesAboutInfo: "Information about services",
  Incomes: "Incomes",
  AboutInfo: "About info",
  ServiceWork: "Service",
  PaymentType: "Payment type",
  User: "User",
  IncorrectUsernameOrPassword: "Incorrect username or password",
  SendEmail: "Sent to email",
  PaidP: "Paid",
  Series: "With serial",
  WithoutSeries: "Without serial",
  NotPaid: "Unpaid",
  CustomerMap: "Customer map",
  AutomaticSalaryCalculation: "Automatic salary calculation",
  Salary: "Salary",
  Retail: "Retail",
  EstimatedSalary: "Estimated salary",
  Bonus: "Bonus",
  Salaries: "Salaries",
  YouHaveSignedOut: "You have signed out!",

};

export default locale;
